import { createTheme } from "@mui/material/styles";
import { brandColors } from "../const/colors";
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/700.css";

export function createAppTheme(mode: "light" | "dark") {
    const isDark = mode === "dark";

    return createTheme({
        palette: {
            mode,

            primary: {
                main: brandColors.primary,
                contrastText: "#ffffff",
            },

            secondary: {
                main: brandColors.secondary,
                contrastText: "#ffffff",
            },

            background: {
                default: isDark
                    ? brandColors.darkBackground
                    : brandColors.background,
                paper: isDark
                    ? brandColors.darkPaper
                    : "#ffffff",
            },

            ...(isDark
                ? {
                    text: {
                        primary: brandColors.darkText,
                        secondary: brandColors.darkMutedText,
                    },
                }
                : {}),

            brand: {
                primary: brandColors.primary,
                secondary: brandColors.secondary,
                background: isDark
                    ? brandColors.darkBackground
                    : brandColors.background,
                accent: isDark
                    ? brandColors.darkAccent
                    : brandColors.accent,
                accentDark: brandColors.accentDark,
            },

            admin: isDark
                ? {
                    sidebarBg: "#121A17",
                    sidebarBorder: brandColors.primary,
                    sidebarText: brandColors.darkMutedText,
                    sidebarTextActive: "#ffffff",
                    sidebarHover: "#1D2A25",
                }
                : {
                    sidebarBg: brandColors.accentDark,
                    sidebarBorder: brandColors.primary,
                    sidebarText: brandColors.background,
                    sidebarTextActive: "#ffffff",
                    sidebarHover: brandColors.primary,
                },
        },

        typography: {
            fontFamily: '"Inter", sans-serif',
            h1: { fontWeight: 700 },
            h2: { fontWeight: 600 },
            h3: { fontWeight: 600 },
            h4: { fontWeight: 600 },
            h5: { fontWeight: 500 },
            h6: { fontWeight: 500 },
            body1: { fontWeight: 400 },
            body2: { fontWeight: 400 },
            button: { fontWeight: 600 },
        },

        components: {
            /* ================= AppBar ================= */
            MuiAppBar: {
                styleOverrides: {
                    root: ({ theme }) => ({
                        /* IMPORTANT: remove default MUI background gradient */
                        backgroundImage: "none",

                        backgroundColor:
                            theme.palette.mode === "dark"
                                ? "rgba(18, 22, 20, 0.72)"
                                : "rgba(249, 247, 243, 0.6)",

                        backdropFilter: "blur(8px)",
                        color: theme.palette.text.primary,
                        boxShadow: "none",
                        borderBottom: `1px solid ${theme.palette.brand.accent}`,
                    }),
                },
            },

            /* ================= Toolbar ================= */
            MuiToolbar: {
                styleOverrides: {
                    root: ({ theme }) => ({
                        [theme.breakpoints.down("sm")]: {
                            paddingLeft: theme.spacing(1),
                            paddingRight: theme.spacing(1),
                        },
                    }),
                },
            },

            //MuiIconButton: {
            //    styleOverrides: {
            //        root: ({ theme }) => ({
            //            color:
            //                theme.palette.mode === "dark"
            //                    ? theme.palette.grey[100]
            //                    : theme.palette.grey[900],

            //            transition:
            //                "background-color 120ms ease, transform 160ms ease",

            //            "&:hover": {
            //                backgroundColor:
            //                    theme.palette.mode === "dark"
            //                        ? "rgba(255,255,255,0.08)"
            //                        : "rgba(0,0,0,0.06)",
            //            },
            //        }),
            //    },
            //},

            MuiDrawer: {
                styleOverrides: {
                    paper: ({ theme }) => ({
                        backgroundColor: theme.palette.admin.sidebarBg,
                        color: theme.palette.admin.sidebarText,
                        borderRight: `1px solid ${theme.palette.admin.sidebarBorder}`,
                    }),
                },
            },


            MuiButton: {
                defaultProps: {
                    disableRipple: true,
                },
            },
        },
    });
}
